module.exports = __webpack_public_path__ + "static/img/2.b8d7a4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p2/2.png
// module id = r74G
// module chunks = 1